import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const SelectedActivitiesContext = createContext({
  selectedActivities: [],
  toggleActivity: (id) => {},
  setSelectedActivities: () => {},
  isActivitySelected: (id) => false
});

export const SelectedActivitiesProvider = ({ children }) => {
  const [selectedActivities, setSelectedActivities] = useState(() => {
    try {
      const saved = localStorage.getItem('selectedActivities');
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('selectedActivities', JSON.stringify(selectedActivities));
    } catch {}
  }, [selectedActivities]);

  const toggleActivity = (id) => {
    // Normalize ID to string for consistent comparison
    const normalizedId = String(id);
    setSelectedActivities(prev => {
      const normalized = prev.map(String);
      return normalized.includes(normalizedId) 
        ? prev.filter(x => String(x) !== normalizedId)
        : [...prev, normalizedId];
    });
  };

  const isActivitySelected = (id) => {
    const normalizedId = String(id);
    return selectedActivities.map(String).includes(normalizedId);
  };

  const value = useMemo(() => ({ selectedActivities, toggleActivity, setSelectedActivities, isActivitySelected }), [selectedActivities]);

  return (
    <SelectedActivitiesContext.Provider value={value}>
      {children}
    </SelectedActivitiesContext.Provider>
  );
};

export const useSelectedActivities = () => useContext(SelectedActivitiesContext);


